import React from 'react'
import PropTypes from 'prop-types'

import './PagesBanner.sass'


const PagesBanner = ({ bgClassName, title }) => {
  // On desktop and tablet, displays banner with topography background image
  // On mobile displays simple text header

  return (
    <header role="banner">
      <div className="hide-on-mobile "> {/* Nested divs here to prevent background image from loading on mobile */}
        <div className={`${bgClassName} pages-banner`}>
          <h1>{title}</h1>
        </div>
      </div>
      <h2 className="hide-on-tablet-and-desktop mobile-banner-header">{title}</h2>
    </header>
  )
}

PagesBanner.propTypes = {
  bgClassName: PropTypes.string,
  title: PropTypes.string
}

PagesBanner.defaultProps = {
  bgClassName: 'topography-bg-1'
}

export default PagesBanner
